import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {AgeRangeComponent} from "./age-range.component";

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/company/:id/agerange', {template: ''});
    }]);
/***/

const ageRangeRoutes: Routes = [
    {path: 'company/:id/agerange', component: AgeRangeComponent},
    {path: 'cars-sara-v2/web/company/:id/agerange', component: AgeRangeComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(ageRangeRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class AgeRangeRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/ageRange/age-range-routing.module.ts